module.exports = __webpack_public_path__ + "static/atomicDex-b07280d9f73b95acba9710128f1f9079.svg";